let cartLocked = false;

document.addEventListener("click", (e) => {
  const cartButton = e.target.closest("cart-drawer-component");
  if (!cartButton) return;

  if (!window.BSS_B2B) return;

  if (cartLocked) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  cartLocked = true;
  e.preventDefault();
  e.stopPropagation();


    BSS_B2B?.observer?.cartSubject?.notifyObserver(
        "CartUpdate",
        "CartMutate"
    );

  setTimeout(() => {
    BSS_B2B?.observer?.cartSubject?.notifyObserver(
      "CartUpdate",
      "CartMutate"
    );

    cartLocked = false;
  }, 3000);
});


const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 


document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 


let counter = 0;
let selector = ".recently-viewed-wrapper"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        window.dispatchEvent(new Event('scroll'));
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 